import { Link } from "react-router-dom";
import { categories } from "@/mocks/products";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function Footer() {
  const { settings } = useSiteSettings();

  const socialIcons = [
    { icon: "ri-instagram-line", href: settings.socialLinks.instagram },
    { icon: "ri-youtube-line", href: settings.socialLinks.youtube },
    { icon: "ri-tiktok-line", href: settings.socialLinks.tiktok },
    { icon: "ri-facebook-circle-line", href: settings.socialLinks.facebook },
  ];

  return (
    <footer className="bg-stone-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            {settings.logoUrl ? (
              <img
                src={settings.logoUrl}
                alt={settings.siteName}
                className="h-10 w-auto object-contain mb-4 brightness-0 invert"
              />
            ) : (
              <p className="text-xl font-bold text-white mb-4">{settings.siteName}</p>
            )}
            <p className="text-stone-400 text-sm leading-relaxed mb-5">
              {settings.slogan || "Seu guia definitivo para encontrar os melhores produtos com os melhores preços. Reviews honestos, comparativos detalhados e ofertas atualizadas diariamente."}
            </p>
            <div className="flex items-center gap-3">
              {socialIcons.map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-orange-500 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-stone-300 mb-4">
              Categorias Populares
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/categoria/${cat.slug}`}
                    className="text-stone-400 hover:text-orange-400 text-sm transition-colors flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-orange-500"></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-stone-300 mb-4">
              Recursos
            </h4>
            <ul className="space-y-2">
              {[
                { label: "Guias de Compra", href: "/guias" },
                { label: "Reviews de Produtos", href: "/guias" },
                { label: "Melhores Ofertas", href: "/ofertas" },

                { label: "Sobre Nós", href: "/" },
                { label: "Contato", href: "/" },
                { label: "Política de Privacidade", href: "/" },
                { label: "Termos de Uso", href: "/" },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-stone-400 hover:text-orange-400 text-sm transition-colors flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-orange-500"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-stone-300 mb-4">
              Receba Ofertas Exclusivas
            </h4>
            <p className="text-stone-400 text-sm mb-4">
              Cadastre seu e-mail e receba as melhores ofertas e reviews antes de todo mundo.
            </p>
            <form className="space-y-3">
              <input
                type="email"
                placeholder="seu@email.com"
                className="w-full px-4 py-2.5 rounded-lg bg-stone-800 border border-stone-700 text-sm text-white placeholder-stone-500 focus:outline-none focus:border-orange-500 transition-colors"
              />
              <button
                type="submit"
                className="w-full py-2.5 rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold transition-colors cursor-pointer whitespace-nowrap"
              >
                Quero Receber Ofertas
              </button>
            </form>
            <p className="text-stone-600 text-xs mt-3">
              Sem spam. Cancele quando quiser.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            {settings.footerText}
          </p>
          <div className="flex items-center gap-4">
            {["Termos", "Privacidade", "Cookies"].map((item) => (
              <Link
                key={item}
                to="/"
                className="text-stone-500 hover:text-stone-300 text-xs transition-colors"
              >
                {item}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
